import api from '@/api';
import Utils from '@/utils';

export const actions = {

    adminNoticesStore({dispatch}, data) {
        data.date = Utils.setDateFormatUSA(data.date);
        data.start_date = Utils.setDateFormatUSA(data.start_date);
        data.expire_date = Utils.setDateFormatUSA(data.expire_date);
        return new Promise((resolve, reject) => {
            dispatch('commonStartLoading');
            api({ url: 'notices', method: 'POST', data: data })
                .then(resp => {
                    dispatch('commonEndLoading');
                    resolve(resp.data);
                })
                .catch(err => {
                    dispatch('commonEndLoading');
                    reject(err)
                })
        })
    },

};
